export default {
  FIR: "RayNeo ARグラス ファームウェアアップデート",
  NO: "現在、モバイルデバイスからのファームウェアアップデートには対応していません",
  TIPS: "ファームウェアをアップデートするには、コンピューターで以下のブラウザをご使用ください",
  pageTitle: "RayNeo ARグラス ファームウェアアップデート",
  connectStep: "接続",
  updateStep: "アップデート",
  supportedModels:
    "対応モデル：RayNeo GT、RayNeo GT MAX、RayNeo Air 4 Pro、RayNeo Air 4、RayNeo Air 3s Pro、RayNeo Air 3s、RayNeo Air 3、RayNeo Air 2s、RayNeo Air 2、RayNeo Air Plus、RayNeo Air 1s",
  desktopBrowserRequirement:
    "ChromeまたはOperaのデスクトップ版（バージョン89以降）をご使用ください。",
  singleDeviceRequirement:
    "アップデート中は、1台のRayNeoグラスのみをコンピューターに接続してください。",
  displayFlickerNotice:
    "グラスの接続後、画面が一時的にちらつく場合がありますが、異常ではありません。",
  blackScreenReminder:
    "アップデート完了後、画面が再点灯するまで約15秒間黒い状態が続きます。その間はグラスの接続を解除しないでください。",
  connectYourGlasses: "グラスを接続",
  connectUsbInstruction:
    "グラスをコンピューターのUSB-Cポートに接続し、<strong>グラスを接続</strong>をクリックしてください。",
  selectDeviceInstruction:
    "メッセージが表示されたら、デバイス一覧からグラスを選択し、<strong>接続</strong>をクリックしてください。",
  windowsConnectionHelp:
    "WindowsでRayNeo Air PlusまたはAir 1sを接続できませんか？",
  connectGlasses: "グラスを接続",
  networkException:
    "ネットワークエラーが発生しました。ネットワーク接続を確認して、もう一度お試しください。",
  windowsRecognitionTitle: "RayNeo Air PlusとAir 1sを認識できません",
  windowsStepOne:
    "1. WinキーとXキーを同時に押します。表示されたメニューで「デバイス マネージャー」をクリックすると、デバイスの一覧が表示されます。",
  windowsStepTwo:
    '2. デバイス一覧の「ほかのデバイス」に「STM32 DownLoad Firmware Update」が表示されている場合は、「STM32 Download Firmware Update」を選択し、<a href="https://zadig.akeo.ie/" target="_blank" rel="noopener noreferrer">zadig</a>をクリックしてドライバーをインストールした後、グラスを接続し直してください。',
  gotIt: "了解しました",
  damagedFirmware: "ファームウェアが破損しています。すぐに修復してください。",
  currentFirmwareVersion: "現在のファームウェアバージョン：{version}",
  latestFirmwareVersion: "すでに最新のファームウェアバージョンです。",
  newFirmwareAvailable:
    "新しいファームウェアバージョン{version}を利用できます。",
  details: "詳細",
  newFirmwareInstructions: "新しいファームウェアバージョンのリリースノート",
  noInstructions: "現在、リリースノートはありません。",
  repairFirmware: "ファームウェアを修復",
  upgradeFirmware: "ファームウェアをアップデート",
  popupInstruction:
    "アップデート中にポップアップウィンドウが表示された場合は、デバイスを選択して「接続」をクリックしてください。",
  fixingFirmware: "ファームウェアを修復しています…",
  upgradingFirmware: "ファームウェアをアップデートしています…",
  doNotCloseDuringUpdate:
    "アップデート中は、このページを閉じたり再読み込みしたりせず、グラスの接続も解除しないでください。",
  firmwareRepairComplete: "ファームウェアの修復が完了しました",
  firmwareUpdateComplete: "ファームウェアのアップデートが完了しました",
  firmwareCompleteDescription:
    "{model}のファームウェアがバージョン{version}に更新されました。",
  rayneoGlasses: "RayNeoグラス",
  firmwareRepairFailed: "ファームウェアの修復に失敗しました",
  firmwareOtaUpdateFailed: "ファームウェアのOTAアップデートに失敗しました",
  retryUpdate: "再度アップデート",
  repeatedProblems:
    "問題が繰り返し発生する場合は、グラスをコンピューターから取り外し、ページを再読み込みしてから、もう一度お試しください。",
  deviceDisconnected:
    "デバイスが切断されました。接続を確認して、もう一度お試しください。",
  networkError:
    "ネットワークエラーが発生しました。ネットワーク接続を確認して、もう一度お試しください。",
  firmwareUpdateFailedReconnect:
    "ファームウェアのアップデートに失敗しました。グラスを接続し直して、もう一度お試しください。",
  firmwareUpdateFailedSelect:
    "ファームウェアのアップデートに失敗しました。デバイスを選択して、もう一度お試しください。",
  firmwareDownloadAddressEmpty:
    "ファームウェアのダウンロード先が設定されていないため、アップデートできません。",
  firmwareUpdateRequestFailed:
    "ファームウェアのアップデート要求に失敗しました。ネットワーク接続を確認して、もう一度お試しください。",
  singleDeviceDuringUpdate:
    "アップデート中は、1台のRayNeoグラスのみをコンピューターに接続してください。",
  failedGetDeviceInformation:
    "デバイス情報を取得できませんでした（{error}）。ページを再読み込みして、もう一度お試しください。",
  deviceConnectionError:
    "デバイス接続エラーが発生しました。グラスを接続し直して、もう一度お試しください。",
  browserUnsupported:
    "現在のブラウザはファームウェアのアップデートに対応していません",
  openWithBrowsers: "以下のブラウザで開いてください",
  browserVersionGreaterThan: "バージョン{version}より新しい",
  mobileNotSupported:
    "現在、モバイルデバイスからのファームウェアアップデートには対応していません",
  useComputerBrowsers:
    "ファームウェアをアップデートするには、コンピューターで以下のブラウザをご使用ください",
  dfuPackageMismatch:
    "ZIP内の.dfuファイルをデバイスのDFUインターフェースに対応付けられませんでした。ファームウェアパッケージとデバイスを確認してください。",
  firmwareDownloadFailed:
    "ファームウェアファイルをダウンロードできませんでした。",
};
